import React from 'react';
import { useSelector } from 'react-redux';
import { useGetPaidChannelComparisonPerformanceChartQuery, useGetPaidChannelComparisonPerformanceTimeSeriesQuery, useGetPaidChannelTableQuery } from '../../redux/api/compassProject';
import PlotContainer from '../PlotContainer';
import TableContainer from '../TableContainer';

const PaidChannelComparison = () => {

    const selectedClient = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedStartDate = useSelector((state) => state.genericReporting.selectedDropdownValues['start_date']);
    const selectedEndDate = useSelector((state) => state.genericReporting.selectedDropdownValues['end_date']);
    const selectedDateGranularity = useSelector((state) => state.genericReporting.selectedDropdownValues['client_name']);
    const selectedDrivers = useSelector((state) => state.compass.drivers);

    return (
        <div>
            <div className='full-width-container'>
                <PlotContainer useApi={useGetPaidChannelComparisonPerformanceChartQuery} useApiArgs={{
                    client_name: selectedClient,
                    start_date: selectedStartDate,
                    end_date: selectedEndDate,
                    granularity: selectedDateGranularity,
                    drivers: selectedDrivers
                }} />
            </div>
            <div className='full-width-container'>
                <PlotContainer useApi={useGetPaidChannelComparisonPerformanceTimeSeriesQuery} useApiArgs={{
                    client_name: selectedClient,
                    start_date: selectedStartDate,
                    end_date: selectedEndDate,
                    granularity: selectedDateGranularity,
                    drivers: selectedDrivers
                }} />
            </div>
            <div className='full-width-container'>
                <TableContainer useApi={useGetPaidChannelTableQuery} apiParams={{
                    client_name: selectedClient,
                    start_date: selectedStartDate,
                    end_date: selectedEndDate,
                    granularity: selectedDateGranularity,
                    drivers: selectedDrivers
                }} />
            </div>
        </div>
    );
};

export default PaidChannelComparison;